<div class="top_btn-tab mt-2" style="display: flex; align-items: center;">
  <button class="default_secondary-btn geo_btn" (click)="upload.click()">Upload Excel</button>
  <button class="default_secondary-btn geo_btn" (click)="export()">Download Excel</button>
</div>
<input
id="files"
style="visibility: hidden;"
type="file"
#upload
(change)="onUploadDoc($event)"
/>

<div class="toggle_view">
  <mat-button-toggle-group
name="fontStyle"
aria-label="Font Style"
color="accent"
class="m-3"

>
<mat-button-toggle value="list" color="accent" (click)="onList()"
  ><mat-icon class="example-tab-icon"
    >list</mat-icon
  ></mat-button-toggle
>
<mat-button-toggle value="grid" (click)="onGrid()"
  ><mat-icon class="example-tab-icon"
    >view_module</mat-icon
  ></mat-button-toggle
>
</mat-button-toggle-group>
</div>



<div class="entry_values" *ngIf="gridView">
  <div class="entry"  *ngFor="let document of documentArrayForm.get('Documents')['controls']; index as i">
    <h1 class="section_name">
      <span class="numb">{{i + 1}}.</span>
      <div class="first-detail">
        <span class="name">{{document?.value.DocumentTitle}} - </span>
      <span class="id">{{document?.value.DocRefNo}}</span>
      </div>
      <span (click)="$event.stopImmediatePropagation()" style="cursor: pointer;">
      <em class="ti-pencil" (click)="onEdit(documentArrayForm.getRawValue(), i)"></em> 
      </span>
    </h1>

    <div class="other_info">
      <p class="purpose" >
        <span>Local: </span>
        <ng-container (click)="$event.stopImmediatePropagation()">
          <span (click)="onSelectDoc(document?.getRawValue())" style="cursor: pointer;">ELP Storage</span>
        </ng-container>
      </p>

      <p class="net_area">
        <span>Third Party Storage: </span>
        <span><a href="{{document.value.Url}}" target="_blank">{{document.value.Url}}</a></span>
      </p>

      <p class="net_area">
        <span>Document Type: </span>
        <span>{{getDocumentTypeName(document?.value.DocumentTypeId)}}</span>
      </p>

      <p class="uom">
        <span>Document Type Code: </span>
        <span>{{getDocumentTypeCodeName(document?.value.DocumentTypeCodeId)}}</span>
      </p>

      <p class="cost">
        <span>URL: </span>
        <span>{{document?.value.Url}}</span>

      </p>

      <p class="map">
        <span>Security Classification: </span>
        <span>{{getSecurityClassificationName(document?.value.SecurityId)}}</span>
      </p>

      <p class="map">
        <span>File Location: </span>
        <span>{{getFileLocationName(document?.value.FileLocationId)}}</span>
      </p>

      <p class="map">
        <span>Remarks: </span>
        <span>{{document?.value.Remarks}}</span>
      </p>
    </div>
  </div>
  </div>


  <div class="card mt-3 " *ngIf="listView">
    <div class="table-responsive">
    <table class="table table-hover" >
      <thead>
        <tr>
          <th scope="col">S/N</th>
          <th scope="col">Document Title</th>
          <th scope="col">DocRefNo</th>
          <th scope="col">Local</th>
          <th scope="col">Third Party Storage</th>
          <th scope="col">Document Type</th>
          <th scope="col">Document Type Code</th>
          <th scope="col">URL</th>
          <th scope="col">Security Classification</th>
          <th scope="col">File Location</th>
          <th scope="col">Remarks</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody >
        <tr  *ngFor="let document of documentArrayForm.get('Documents')['controls']; index as i"
        >
          <th scope="row">{{i + 1}}</th>
          <td>{{document?.value.DocumentTitle}}</td>
          <td>{{document?.value.DocRefNo}}</td>
          <td> <span (click)="onSelectDoc(document?.getRawValue())" style="cursor: pointer;">ELP Storage</span></td>
          <td><a href="{{document.value.Url}}" target="_blank">{{document.value.Url}}</a></td>
          <td>{{getDocumentTypeName(document?.value.DocumentTypeId)}}</td>
          <td>{{getDocumentTypeCodeName(document?.value.DocumentTypeCodeId)}}</td>
          <td>{{document?.value.Url}}</td>
          <td>{{getSecurityClassificationName(document?.value.SecurityId)}}</td>
          <td>{{getFileLocationName(document?.value.FileLocationId)}}</td>
          <td>{{document?.value.Remarks}}</td>
          <td (click)="$event.stopImmediatePropagation()" style="cursor: pointer;">
            <em class="ti-pencil" (click)="onEdit(documentArrayForm.getRawValue(), i)"></em> 
           </td>
        </tr>

      </tbody>
    </table>
  </div>
  </div>
